<app-table
    #userProfileMessagesTable
    [translatePrefix]="prefix"
    dataKey="id"
    [columns]="columns"
    [defaultSorters]="[{ column: 'createdAt', direction: 'DESC' }]"
    [gridData]="store.data.getMyMessageRecipients()"
    [refreshCallback]="store.api.getMyMessageRecipients"
    [refreshCallbackFragment]="fragment"
    [transformItem]="transformItem"
    [showDelete]="isWidget() ? false : null"
    [showClearFilter]="!isWidget()"
    [additionalFilter]="additionalFilter()"
    [hideCheckboxes]="true"
    (detailCallback)="detail($event)"
    (deleteCallbackWithEvent)="delete($event)"
></app-table>
